/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { FlexContainer } from "@nordcloud/gnui";
import { FormWrap } from "~/components";
import { Provider, ProviderSelector } from "./ProviderSelector";

const PROVIDER_CONFIG = {
  [Provider.AWS]: {
    icon: "aws",
    label: "AWS",
  },
  [Provider.AZURE_EA]: {
    icon: "azure",
    label: "Azure EA",
  },
  [Provider.GCP]: {
    icon: "gcp",
    label: "Google Cloud",
  },
} as const;

type Props = {
  onSubmit: (data: Provider) => void;
};

export function ProviderForm({ onSubmit }: Props) {
  const [selectedProvider, setSelectedProvider] =
    React.useState<Provider | null>(null);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (selectedProvider != null) {
      onSubmit(selectedProvider);
    }
  };

  const disableSubmit = selectedProvider == null;

  return (
    <FormWrap
      footerProps={{ nextButtonProps: { disabled: disableSubmit } }}
      onSubmit={handleSubmit}
    >
      <FlexContainer wrap="wrap" justifyContent="center">
        <ProviderSelector
          providerConfig={PROVIDER_CONFIG}
          selected={selectedProvider}
          onSelect={(provider) => setSelectedProvider(provider)}
        />
      </FlexContainer>
    </FormWrap>
  );
}
